import AvatarTimer from '@/components/ANewDesign/PlayerCell/AvatarTimer'
import { PlayerRole } from '@/components/ANewDesign/PlayerRole'
import { PokerCard } from '@/components/GameAssets/Cards/PokerCard'
import { useTableLayoutPosition } from '@/components/GameAssets/Table/useTableLayout'
import { DS } from '@/design-system'
import { useResponsive } from '@/screens/new-design/hooks/useResponsive'
import { Suit, Value } from 'pokersolver'
import { useMemo } from 'react'
import { FlexAlignType, View, ViewStyle } from 'react-native'
import { Text } from 'react-native'
import { createComponent } from 'react-native-small-ui'

const Row = createComponent(View, {
  flexDirection: 'row'
})

type PlayerCardsProps = {
  cards: string[]
  isCardDisabled?: boolean
  containerStyle?: ViewStyle
}
export const HandCards = ({ cards, containerStyle, isCardDisabled }: PlayerCardsProps) => {
  const layout = useTableLayoutPosition()
  const { verticalScale } = useResponsive()

  // const cardWidth = verticalScale(48)
  const cardWidth = verticalScale(layout.handCard.width)

  const cardDisabledStyle = isCardDisabled
    ? {
        opacity: 0.75
      }
    : undefined

  return (
    <Row gap={2} style={containerStyle}>
      <PokerCard.Flip
        suit={cards?.[0]?.[1] as Suit | undefined}
        value={cards?.[0]?.[0] as Value | undefined}
        side={cards?.[0] !== undefined ? 'front' : 'back'}
        size={cardWidth}
        soundEnable
        containerStyle={{
          transform: [{ rotate: '-5deg' }]
        }}
        frontSideOptions={{
          cardStyle: cardDisabledStyle
        }}
      />
      <PokerCard.Flip
        suit={cards?.[1]?.[1] as Suit | undefined}
        value={cards?.[1]?.[0] as Value | undefined}
        side={cards?.[1] !== undefined ? 'front' : 'back'}
        size={cardWidth}
        soundEnable
        containerStyle={{
          transform: [{ rotate: '5deg' }]
        }}
        frontSideOptions={{
          cardStyle: cardDisabledStyle
        }}
      />
    </Row>
  )
}
